import type { TFunction } from "i18next";

export interface PaymentSuccessCopy {
  header: string;
  description: string;
}

/**
 * Returns localized header/description for the post-purchase success screen.
 * `appToBuild` may be suffixed with `_ai` (e.g. `electrical_ai`) when an
 * AI-only purchase was made — mirrors the previous appBanners lookup table.
 */
export function getPaymentSuccessCopy(
  t: TFunction,
  appToBuild: string,
): PaymentSuccessCopy {
  switch (appToBuild) {
    case "electrical":
      return {
        header: t("paymentSuccess.header_electrical_default"),
        description: t("paymentSuccess.description_electrical_default"),
      };
    case "plumbing":
      return {
        header: t("paymentSuccess.header_plumbing"),
        description: t("paymentSuccess.description_plumbing_default"),
      };
    case "electrical_us":
      return {
        header: t("paymentSuccess.header_electrical_us"),
        description: t("paymentSuccess.description_electrical_us_default"),
      };
    case "ibew_aptitude":
      return {
        header: t("paymentSuccess.header_ibew_aptitude"),
        description: t("paymentSuccess.description_ibew_aptitude_default"),
      };
    case "electrical_ai":
      return {
        header: t("paymentSuccess.header_ai_unlocked"),
        description: t("paymentSuccess.description_electrical_ai"),
      };
    case "plumbing_ai":
      return {
        header: t("paymentSuccess.header_ai_unlocked"),
        description: t("paymentSuccess.description_plumbing_ai"),
      };
    default:
      return {
        header: t("paymentSuccess.header_electrical"),
        description: t("paymentSuccess.description_electrical"),
      };
  }
}
